import lscache from "lscache";
import cache from "config/cache";
// import { sampleSize, sample, sortBy, shuffle, random } from "lodash";
// Interfaces
import {
  State,
  Action,
  RoundState,
  Abilities,
  VetoState,
  // RoundState,
  // Player,
  // Rule,
} from "context/interfaces/GameContextInterface";
// Utilities
// import GameRules from "./GameRules";

export function GameReducer(state: State, action: Action) {
  let {
    code,
    isStarted,
    roundState,
    hostId,
    // player,
    players,
    playersNumber,
    remainingPlayersNumber,
    fascistsIndexes,
    hitlerIndex,
    liberalRulesApproval,
    fascistRulesApproval,
    electionDeclined,
    drawRules,
    discardRules,
    gameRules,
    // isPresidentIndex,
    // isChancellorIndex,
    // wasPresidentIndex,
    // wasChancellorIndex,
    dashboardRules,
    activeAbility,
    // chosenPlayerIndex,
    // returnPresidentIndex,
    requestRestart,
    vetoState,
  } = state;

  switch (action.type) {
    case "AUTHENTICATE": {
      lscache.set(cache.GamePlayer, action.payload);

      return {
        ...state,
        player: action.payload,
      };
    }

    case "UPDATE_STATE": {
      const payload = action.payload;

      return {
        ...state,
        code: payload?.code ?? code,
        isStarted: payload?.isStarted ?? isStarted,
        roundState: payload?.roundState ?? roundState,
        hostId: payload?.hostId ?? hostId,
        players: payload?.players ?? players,
        playersNumber: payload?.playersNumber ?? playersNumber,
        remainingPlayersNumber:
          payload?.remainingPlayersNumber ?? remainingPlayersNumber,
        fascistsIndexes: payload?.fascistsIndexes ?? fascistsIndexes,
        hitlerIndex: payload?.hitlerIndex ?? hitlerIndex,
        liberalRulesApproval:
          payload?.liberalRulesApproval ?? liberalRulesApproval,
        fascistRulesApproval:
          payload?.fascistRulesApproval ?? fascistRulesApproval,
        electionDeclined: payload?.electionDeclined ?? electionDeclined,
        drawRules: payload?.drawRules ?? drawRules,
        discardRules: payload?.discardRules ?? discardRules,
        gameRules: payload?.gameRules ?? gameRules,
        isPresidentIndex: payload?.isPresidentIndex ?? undefined,
        isChancellorIndex: payload?.isChancellorIndex ?? undefined,
        wasPresidentIndex: payload?.wasPresidentIndex ?? undefined,
        wasChancellorIndex: payload?.wasChancellorIndex ?? undefined,
        dashboardRules: payload?.dashboardRules ?? dashboardRules,
        activeAbility: payload?.activeAbility ?? activeAbility,
        chosenPlayerIndex: payload?.chosenPlayerIndex ?? undefined,
        returnPresidentIndex: payload?.returnPresidentIndex ?? undefined,
        vetoState: payload?.vetoState ?? vetoState,
      };
    }

    case "RESET_STATE": {
      return {
        ...state,
        code: lscache.get(cache.GameCode) || null,
        isStarted: lscache.get(cache.GameIsStarted),
        roundState:
          lscache.get(cache.GameRoundState) || RoundState.PickingChancellor,
        hostId: lscache.get(cache.GameHostId) || null,
        player: lscache.get(cache.GamePlayer) || null,
        players: lscache.get(cache.GamePlayers) || [],
        playersNumber: lscache.get(cache.GamePlayersNumber) || null,
        remainingPlayersNumber:
          lscache.get(cache.GameRemainingPlayersNumber) || null,
        fascistsIndexes: lscache.get(cache.GameFascistsIndexes) || [],
        hitlerIndex: lscache.get(cache.GameHitlerIndex),
        liberalRulesApproval: lscache.get(cache.GameLiberalRulesApproval) || 0,
        fascistRulesApproval: lscache.get(cache.GameFascistRulesApproval) || 0,
        electionDeclined: lscache.get(cache.GameElectionDeclined) || 0,
        drawRules: lscache.get(cache.GameDrawRules) || [],
        discardRules: lscache.get(cache.GameDiscardRules) || [],
        gameRules: lscache.get(cache.GameGameRules) || null,
        isPresidentIndex: lscache.get(cache.GameIsPresidentIndex),
        isChancellorIndex: lscache.get(cache.GameIsChancellorIndex),
        wasPresidentIndex: lscache.get(cache.GameWasPresidentIndex),
        wasChancellorIndex: lscache.get(cache.GameWasChancellorIndex),
        dashboardRules: lscache.get(cache.GameDashboardRules) || [],
        activeAbility: lscache.get(cache.GameActiveAbility) || Abilities.None,
        chosenPlayerIndex: lscache.get(cache.GameChosenPlayerIndex),
        returnPresidentIndex: lscache.get(cache.GameReturnPresidentIndex),
        requestRestart: lscache.get(cache.GameRequestRestart) || false,
        vetoState: lscache.get(cache.GameVetoState) || VetoState.None,
      };
    }

    case "TOGGLE_REQUEST_RESTART": {
      return {
        ...state,
        requestRestart: !requestRestart,
      };
    }

    // case "BACK_UP": {
    //   lscache.set(cache.GamePlayer, code);
    //   lscache.set(cache.GamePlayer, isStarted);
    //   lscache.set(cache.GamePlayer, hostId);
    //   lscache.set(cache.GamePlayer, player);
    //   lscache.set(cache.GamePlayers, players);
    //   lscache.set(cache.GameRoundState, roundState);
    //   lscache.set(cache.GamePlayersNumber, playersNumber);
    //   lscache.set(cache.GameRemainingPlayersNumber, remainingPlayersNumber);
    //   lscache.set(cache.GameFascistsIndexes, fascistsIndexes);
    //   lscache.set(cache.GameHitlerIndex, hitlerIndex);
    //   lscache.set(cache.GameLiberalRulesApproval, liberalRulesApproval);
    //   lscache.set(cache.GameFascistRulesApproval, fascistRulesApproval);
    //   lscache.set(cache.GameElectionDeclined, electionDeclined);
    //   lscache.set(cache.GameDrawRules, drawRules);
    //   lscache.set(cache.GameDiscardRules, discardRules);
    //   lscache.set(cache.GameGameRules, gameRules);
    //   lscache.set(cache.GameIsPresidentIndex, isPresidentIndex);
    //   lscache.set(cache.GameIsChancellorIndex, isChancellorIndex);
    //   lscache.set(cache.GameWasPresidentIndex, wasPresidentIndex);
    //   lscache.set(cache.GameWasChancellorIndex, wasChancellorIndex);
    //   lscache.set(cache.GameModalActive, modalActive);
    //   lscache.set(cache.GameDashboardRules, dashboardRules);
    //   lscache.set(cache.GameActiveAbility, activeAbility);
    //   lscache.set(cache.GameChosenPlayerIndex, chosenPlayerIndex);
    //   lscache.set(cache.GameReturnPresidentIndex, returnPresidentIndex);
    //   lscache.set(cache.GameRequestRestart, requestRestart);

    //   return { ...state };
    // }

    // case "SET_PLAYERS_NUMBER": {
    //   localStorage.clear();

    //   let gameRules;
    //   switch (true) {
    //     case 5 <= action.payload && action.payload <= 6:
    //       gameRules = GameRules.PLAYERS_5_6;
    //       break;
    //     case 7 <= action.payload && action.payload <= 8:
    //       gameRules = GameRules.PLAYERS_7_8;
    //       break;
    //     case 9 <= action.payload && action.payload <= 10:
    //       gameRules = GameRules.PLAYERS_9_10;
    //       break;
    //   }

    //   lscache.set(cache.GameRemainingPlayersNumber, action.payload);
    //   lscache.set(cache.GamePlayersNumber, action.payload);
    //   lscache.set(cache.GameGameRules, gameRules);

    //   return {
    //     ...state,
    //     remainingPlayersNumber: action.payload,
    //     playersNumber: action.payload,
    //     gameRules: gameRules,
    //   };
    // }

    // case "CREATE_PLAYERS": {
    //   const players: Player[] = [];
    //   for (const iterator of action.payload) {
    //     players.push({
    //       name: iterator,
    //       isLiberal: true,
    //       isHitler: false,
    //       isDead: false,
    //     });
    //   }
    //   return { ...state, players: players };
    // }

    // case "ASSIGN_ROLES": {
    //   const indexes: number[] = Array.from(Array(playersNumber).keys());
    //   let fascistsIndexes: number[] = [];
    //   let hitlerIndex: number = 0;

    //   fascistsIndexes = sampleSize(indexes, gameRules.fascistsNumber);
    //   hitlerIndex = sample(fascistsIndexes)!;

    //   fascistsIndexes.map((item) => (players[item].isLiberal = false));
    //   fascistsIndexes = sortBy(fascistsIndexes);
    //   players[hitlerIndex!].isHitler = true;
    //   lscache.set(cache.GamePlayers, players);
    //   lscache.set(cache.GameFascistsIndexes, fascistsIndexes);
    //   lscache.set(cache.GameHitlerIndex, hitlerIndex);
    //   return {
    //     ...state,
    //     players,
    //     fascistsIndexes,
    //     hitlerIndex,
    //   };
    // }

    // case "CHECK_RULES": {
    //   // create rules in the start of game
    //   if (!drawRules.length && wasPresidentIndex === null) {
    //     drawRules = [
    //       ...new Array(6).fill(Rule.Liberal),
    //       ...new Array(11).fill(Rule.Fascist),
    //     ];
    //     drawRules = shuffle(drawRules);
    //   }

    //   // shuffle rules if we have not enough rules to play a round
    //   else if (drawRules.length <= 2) {
    //     drawRules = [...drawRules, ...discardRules];
    //     drawRules = shuffle(drawRules);
    //     discardRules = [];
    //   }

    //   return {
    //     ...state,
    //     drawRules,
    //     discardRules,
    //   };
    // }

    // case "INIT_GOVERNMENT": {
    //   if (isPresidentIndex === null)
    //     isPresidentIndex = random(state.playersNumber - 1);

    //   return {
    //     ...state,
    //     isPresidentIndex,
    //   };
    // }

    // case "NEXT_GOVERNMENT": {
    //   if (isPresidentIndex !== null && !electionDeclined) {
    //     wasPresidentIndex = isPresidentIndex;
    //     wasChancellorIndex = isChancellorIndex;
    //   }

    //   if (electionDeclined === 3) {
    //     electionDeclined = 0;
    //     const deletedRule = drawRules.splice(0, 1);
    //     if (deletedRule[0]) fascistRulesApproval++;
    //     else liberalRulesApproval++;

    //     wasPresidentIndex = null;
    //     wasChancellorIndex = null;
    //   }

    //   if (liberalRulesApproval === 5 || fascistRulesApproval === 6)
    //     roundState = RoundState.GameFinished;
    //   else roundState = RoundState.PickingChancellor;

    //   if (isPresidentIndex === null)
    //     isPresidentIndex = random(state.playersNumber - 1);
    //   else if (activeAbility === Abilities.NextPresident) {
    //     returnPresidentIndex = (isPresidentIndex! + 1) % state.playersNumber;
    //     isPresidentIndex = chosenPlayerIndex;
    //     chosenPlayerIndex = null;
    //     isChancellorIndex = null;
    //     activeAbility = Abilities.None;
    //   } else if (returnPresidentIndex) {
    //     isPresidentIndex = returnPresidentIndex;
    //     isChancellorIndex = null;
    //     returnPresidentIndex = null;
    //   } else {
    //     isPresidentIndex = (isPresidentIndex! + 1) % state.playersNumber;
    //     isChancellorIndex = null;
    //   }

    //   while (players[isPresidentIndex!].isDead) {
    //     isPresidentIndex = (isPresidentIndex! + 1) % state.playersNumber;
    //   }

    //   return {
    //     ...state,
    //     roundState,
    //     isPresidentIndex,
    //     isChancellorIndex,
    //     wasPresidentIndex,
    //     wasChancellorIndex,
    //     activeAbility,
    //     chosenPlayerIndex,
    //     returnPresidentIndex,
    //     electionDeclined,
    //     drawRules,
    //     fascistRulesApproval,
    //     liberalRulesApproval,
    //   };
    // }

    // case "PICK_CHANCELLOR": {
    //   return {
    //     ...state,
    //     roundState: RoundState.votingGovernment,
    //     isChancellorIndex: action.payload,
    //   };
    // }

    // case "HANDLE_VOTING": {
    //   if (action.payload) {
    //     if (fascistRulesApproval >= 3 && players[isChancellorIndex!].isHitler) {
    //       return {
    //         ...state,
    //         roundState: RoundState.GameFinished,
    //         modalActive: false,
    //       };
    //     }

    //     const dashboardRules = drawRules.splice(0, 3);
    //     return {
    //       ...state,
    //       roundState: RoundState.PresidentRule,
    //       electionDeclined: 0,
    //       drawRules,
    //       dashboardRules,
    //     };
    //   }

    //   electionDeclined++;

    //   return {
    //     ...state,
    //     roundState: RoundState.WaitToStartAnotherRound,
    //     electionDeclined,
    //     drawRules,
    //     modalActive: false,
    //   };
    // }

    // case "PRESIDENT_REJECT_RULE": {
    //   const discardedRule = dashboardRules.splice(action.payload, 1);
    //   discardRules.push(discardedRule[0]);

    //   return {
    //     ...state,
    //     roundState: RoundState.ChancellorRule,
    //     discardRules,
    //     dashboardRules,
    //   };
    // }

    // case "CHANCELLOR_PASS_RULE": {
    //   roundState = RoundState.WaitToStartAnotherRound;

    //   const discardedRule = dashboardRules.splice(1 - action.payload, 1);
    //   discardRules.push(discardedRule[0]);
    //   if (dashboardRules[0]) {
    //     fascistRulesApproval++;
    //     if (gameRules.abilities[fascistRulesApproval - 1] !== Abilities.None)
    //       roundState = RoundState.AbilityActive;
    //     activeAbility = gameRules.abilities[fascistRulesApproval - 1];
    //   } else liberalRulesApproval++;

    //   if (liberalRulesApproval === 5 || fascistRulesApproval === 6)
    //     roundState = RoundState.GameFinished;

    //   return {
    //     ...state,
    //     roundState,
    //     modalActive: false,
    //     discardRules,
    //     dashboardRules: [],
    //     fascistRulesApproval,
    //     liberalRulesApproval,
    //     activeAbility,
    //   };
    // }

    // case "VETO": {
    //   discardRules = [...discardRules, ...dashboardRules];

    //   return {
    //     ...state,
    //     roundState: RoundState.WaitToStartAnotherRound,
    //     discardRules,
    //     dashboardRules: [],
    //   };
    // }

    // case "ABILITY_DONE": {
    //   return {
    //     ...state,
    //     roundState: RoundState.WaitToStartAnotherRound,
    //     activeAbility: Abilities.None,
    //   };
    // }

    // case "ABILITY_HALF_DONE": {
    //   return {
    //     ...state,
    //     roundState: RoundState.WaitToStartAnotherRound,
    //   };
    // }

    // case "SET_CHOSEN": {
    //   return {
    //     ...state,
    //     chosenPlayerIndex: action.payload,
    //   };
    // }

    // case "KILL_PLAYER": {
    //   players[action.payload].isDead = true;

    //   remainingPlayersNumber--;

    //   return {
    //     ...state,
    //     players,
    //     remainingPlayersNumber,
    //     roundState: players[action.payload].isHitler
    //       ? RoundState.GameFinished
    //       : RoundState.WaitToStartAnotherRound,
    //     activeAbility: Abilities.None,
    //   };
    // }

    default: {
      throw new Error(`Unhandled action type`);
    }
  }
}
